import React from 'react';
import Icon from '../../../components/AppIcon';

const ConsultationProcess = () => {
  const processSteps = [
    {
      id: 1,
      title: "Initial Discussion",
      description: "We\'ll review your requirements and discuss your current challenges in a 30-minute consultation call.",
      duration: "30 minutes",
      icon: "Phone",
      details: [
        "Understand your business needs",
        "Review current infrastructure",
        "Discuss timeline and budget",
        "Answer your questions"
      ]
    },
    {
      id: 2,
      title: "On-Site Assessment",
      description: "Our certified technicians will conduct a comprehensive evaluation of your current infrastructure.",
      duration: "2-4 hours",
      icon: "Search",
      details: [
        "Physical infrastructure audit",
        "Performance testing",
        "Compliance verification",
        "Site documentation"
      ]
    },
    {
      id: 3,
      title: "Custom Proposal",
      description: "We'll develop a detailed proposal with technical specifications, timeline, and transparent pricing.",
      duration: "2-3 business days",
      icon: "FileText",
      details: [
        "Technical specifications",
        "Project timeline",
        "Detailed pricing",
        "ROI analysis"
      ]
    },
    {
      id: 4,
      title: "Implementation Planning",
      description: "Once approved, we'll create a detailed implementation plan to minimize business disruption.",
      duration: "1-2 weeks",
      icon: "Calendar",
      details: [
        "Project scheduling",
        "Resource allocation",
        "Risk mitigation",
        "Communication plan"
      ]
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-brand-moderate p-6 md:p-8">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-text-primary mb-3">What to Expect</h2>
        <p className="text-text-secondary max-w-2xl mx-auto">
          Our proven consultation process ensures you get the right solution for your business needs. 
          Here's how we work together to transform your infrastructure.
        </p>
      </div>
      <div className="space-y-8">
        {processSteps?.map((step, index) => (
          <div key={step?.id} className="relative">
            {/* Connection Line */}
            {index < processSteps?.length - 1 && (
              <div className="absolute left-6 top-16 w-0.5 h-16 bg-border" />
            )}
            
            <div className="flex items-start space-x-6">
              {/* Step Icon */}
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
                  <Icon name={step?.icon} size={20} className="text-white" />
                </div>
              </div>

              {/* Step Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-lg font-semibold text-text-primary">
                    Step {step?.id}: {step?.title}
                  </h3>
                  <span className="text-sm text-text-secondary bg-muted px-3 py-1 rounded-full">
                    {step?.duration}
                  </span>
                </div>
                
                <p className="text-text-secondary mb-4">
                  {step?.description}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {step?.details?.map((detail, detailIndex) => (
                    <div key={detailIndex} className="flex items-center space-x-2">
                      <Icon name="Check" size={16} className="text-accent flex-shrink-0" />
                      <span className="text-sm text-text-secondary">{detail}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Guarantee Section */}
      <div className="mt-8 p-6 bg-accent/10 border border-accent/20 rounded-lg">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <Icon name="Shield" size={24} className="text-accent" />
          </div>
          <div>
            <h4 className="font-semibold text-text-primary mb-2">Our Consultation Guarantee</h4>
            <ul className="space-y-1 text-sm text-text-secondary">
              <li className="flex items-center space-x-2">
                <Icon name="Check" size={14} className="text-accent" />
                <span>No-obligation assessment and consultation</span>
              </li>
              <li className="flex items-center space-x-2">
                <Icon name="Check" size={14} className="text-accent" />
                <span>Transparent pricing with no hidden fees</span>
              </li>
              <li className="flex items-center space-x-2">
                <Icon name="Check" size={14} className="text-accent" />
                <span>Detailed documentation of all findings</span>
              </li>
              <li className="flex items-center space-x-2">
                <Icon name="Check" size={14} className="text-accent" />
                <span>100% satisfaction guarantee on consultation quality</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationProcess;